import { CATEGORY_MODEL_CLASS_NAME } from 'models/daos/category/constants'
import { getSectionNameFromClassNameModelUtil } from 'models/utils/get-section-name'
import { REDUX_CLASS_NAME_TO_DOMAIN } from 'modules/redux/constants'

/**
 * Gets the domain name from the given className.
 * @param  {string} className
 * @param  {Instance} [associatedInstance]
 * @returns {string}
 */
function getDomainPathReduxUtil (className, associatedInstance) {
  if (className === CATEGORY_MODEL_CLASS_NAME && associatedInstance) {
    const section = getSectionNameFromClassNameModelUtil(associatedInstance.className)
    return `${REDUX_CLASS_NAME_TO_DOMAIN[className]}.${section}`
  }
  return REDUX_CLASS_NAME_TO_DOMAIN[className]
}

export {
  getDomainPathReduxUtil
}
